export default __webpack_public_path__ + "static/media/profile.6befe7b1.svg";